/**
 * Element UI 自定义主题：按官方 theme-chalk 主色簇算法运行时替换。
 * 门户使用官方 theme-chalk，源主色为 #409EFF。
 */

const CHALK_STYLE_ID = 'wl-element-chalk-theme'
/** 与 public/element-themes/base.css 内主色一致（来自管理端主题包） */
export const ELEMENT_THEME_BASE_PRIMARY = '#6397F1'

function pad2(n) {
  const s = n.toString(16)
  return s.length === 1 ? '0' + s : s
}

export function getThemeCluster(theme) {
  const tintColor = (color, tint) => {
    let red = parseInt(color.slice(0, 2), 16)
    let green = parseInt(color.slice(2, 4), 16)
    let blue = parseInt(color.slice(4, 6), 16)
    if (tint === 0) {
      return [red, green, blue].join(',')
    }
    red += Math.round(tint * (255 - red))
    green += Math.round(tint * (255 - green))
    blue += Math.round(tint * (255 - blue))
    red = Math.min(255, red)
    green = Math.min(255, green)
    blue = Math.min(255, blue)
    return `#${pad2(red)}${pad2(green)}${pad2(blue)}`
  }

  const shadeColor = (color, shade) => {
    let red = parseInt(color.slice(0, 2), 16)
    let green = parseInt(color.slice(2, 4), 16)
    let blue = parseInt(color.slice(4, 6), 16)
    red = Math.round((1 - shade) * red)
    green = Math.round((1 - shade) * green)
    blue = Math.round((1 - shade) * blue)
    return `#${pad2(red)}${pad2(green)}${pad2(blue)}`
  }

  const clusters = [theme]
  for (let i = 0; i <= 9; i++) {
    clusters.push(tintColor(theme, Number((i / 10).toFixed(2))))
  }
  clusters.push(shadeColor(theme, 0.1))
  return clusters
}

function updateStyle(style, oldCluster, newCluster) {
  let newStyle = style
  oldCluster.forEach((color, index) => {
    const re = new RegExp(color.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'ig')
    newStyle = newStyle.replace(re, newCluster[index])
  })
  return newStyle
}

let chalkCssCache = null
let chalkLoading = null

function chalkCssUrl() {
  const base = (typeof process !== 'undefined' && process.env && process.env.BASE_URL) || '/'
  return `${base}element-themes/base.css`
}

export function loadChalkCss() {
  if (chalkCssCache) return Promise.resolve(chalkCssCache)
  if (chalkLoading) return chalkLoading
  chalkLoading = fetch(chalkCssUrl())
    .then(res => {
      if (!res.ok) throw new Error('加载 Element 主题 CSS 失败')
      return res.text()
    })
    .then(css => {
      chalkCssCache = css.replace(/@font-face\s*\{[^}]+\}/g, '')
      return chalkCssCache
    })
    .finally(() => {
      chalkLoading = null
    })
  return chalkLoading
}

/**
 * @param {string} primaryColor 目标主色，如 #2F6FED
 * @param {string} [fromPrimary] 源主色，默认与 base.css 一致 #6397F1
 */
export function applyElementChalkTheme(primaryColor, fromPrimary = ELEMENT_THEME_BASE_PRIMARY) {
  const target = String(primaryColor || '').replace('#', '').toUpperCase()
  const from = String(fromPrimary || ELEMENT_THEME_BASE_PRIMARY).replace('#', '').toUpperCase()
  if (!/^[0-9A-F]{6}$/.test(target)) {
    return Promise.reject(new Error('invalid primary color'))
  }

  return loadChalkCss().then(css => {
    const oldCluster = getThemeCluster(from)
    const newCluster = getThemeCluster(target)
    const nextCss = updateStyle(css, oldCluster, newCluster)

    let el = document.getElementById(CHALK_STYLE_ID)
    if (!el) {
      el = document.createElement('style')
      el.id = CHALK_STYLE_ID
      document.head.appendChild(el)
    }
    el.innerText = nextCss
    document.documentElement.setAttribute('data-element-primary', `#${target}`)
    return `#${target}`
  })
}
